<template>
  <div
    :data-cy="`session-history-${session.id}`"
    class="flex flex-row items-center space-x-4 rounded-sm p-2"
    :class="{ 'bg-label/10': isActive }"
  >
    <div class="h-5 w-5">
      <icon-base
        :icon="IconAINav"
        class="text-label"
        width="20"
        height="20"
        view-box="0 0 30 30"
      />
    </div>
    <div class="flex w-[calc(100%-35px)] flex-col">
      <div class="grid grid-cols-10 items-center justify-between">
        <div class="col-span-9 flex items-center justify-start space-x-1">
          <lf-h4 v-if="session.agent?.name" class="max-w-1/3 truncate">
            {{ session.agent.name }}
          </lf-h4>
          <div
            v-if="session.agent?.name && session.application_name"
            class="text-headline"
          >
            &bull;
          </div>
          <lf-h4 v-if="session.application_name" class="max-w-1/3 truncate">
            {{ session.application_name }}
          </lf-h4>
          <lf-tag v-if="session.client?.name" size="xs" class="max-w-1/3">
            <div class="truncate text-label">
              {{ session.client.name }}
            </div>
          </lf-tag>
        </div>
        <div class="col-span-1 flex items-center justify-end">
          <date-time
            v-if="session.updated_at"
            :date="session.updated_at"
            is-fixed
            show-time-if-today
            :format="format"
            class="truncate text-xs"
          />
        </div>
      </div>
      <div
        v-if="session.first_message?.message"
        class="max-w-4/5 truncate text-xs text-label"
      >
        {{ session.first_message.message }}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import IconAINav from "@/components/icons/IconAINav.vue";
import DateTime from "@/components/ui/ConvertibleDateTime.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfH4 from "@/components/ui/text/LfHeading4.vue";
import LfTag from "@/components/ui/text/LfTag.vue";

import type { AiAgentSession } from "@/models/aiAgents";

const { session, isActive = false } = defineProps<{
  session: AiAgentSession;
  isActive?: boolean;
}>();

const format = computed(() => {
  const isCurrentYear =
    new Date(session.updated_at).getFullYear() === new Date().getFullYear();

  return isCurrentYear ? "MMMM dd" : "MMMM dd, yyyy";
});
</script>
